function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg_12",
  x1: 0,
  y1: 0,
  x2: 1,
  y2: 0
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2b2b2b",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#d4d4d4",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg_34",
  x1: 1,
  y1: 0,
  x2: 0,
  y2: 0
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2b2b2b",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#d4d4d4",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg_36",
  x1: 0,
  y1: 1,
  x2: 0,
  y2: 0
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2b2b2b",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#d4d4d4",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg_143",
  x1: 0.80469,
  y1: 1,
  x2: 1,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9db5b5",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#624a4a",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg_163",
  x1: 0.5,
  y1: 0.5,
  x2: 1,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#c9c9c9",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#363636",
  offset: 1
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "null"
}, /*#__PURE__*/React.createElement("rect", {
  x: -1,
  y: -1,
  width: 602,
  height: 602,
  id: "canvas_background",
  fill: "#c9c9c9",
  stroke: "null"
}), /*#__PURE__*/React.createElement("g", {
  id: "canvasGrid",
  display: "none",
  stroke: "null"
}, /*#__PURE__*/React.createElement("rect", {
  id: "svg_1",
  width: 1600,
  height: 1200,
  strokeWidth: 0,
  fill: "url(#gridpattern)",
  stroke: "null"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  stroke: "null",
  transform: "rotate(90) translate(0, -600)"
}, /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  fill: "url(#svg_143)",
  strokeWidth: 1.5,
  x: 0.7481,
  y: 0.41013,
  width: 157.98991,
  height: 599.37381,
  id: "svg_5"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  fill: "url(#svg_12)",
  strokeWidth: 1.5,
  x: 139.12409,
  y: -0.14809,
  width: 40,
  height: 599.9006,
  id: "svg_9"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009e9e",
  strokeWidth: 1.5,
  d: "m53.17431,506.3862l-15.06253,15.06793l15.06393,15.06512l5.47909,-5.479l-9.5875,-9.58612l9.58551,-9.58614l-5.4785,-5.48179l0,0zm22.04519,0l-5.47513,5.48041l9.58554,9.58612l-9.58554,9.58495l5.47513,5.47897l15.06594,-15.0665l-15.06594,-15.06395z",
  id: "svg_153",
  stroke: "#d36200"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009e9e",
  strokeWidth: 1.5,
  d: "m53.17431,351.34646l-15.06253,15.06793l15.06393,15.06512l5.47909,-5.479l-9.5875,-9.58612l9.58551,-9.58614l-5.4785,-5.48179l0,0zm22.04519,0l-5.47513,5.48041l9.58554,9.58612l-9.58554,9.58495l5.47513,5.47897l15.06594,-15.0665l-15.06594,-15.06395z",
  id: "svg_172",
  stroke: "#d36200"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009e9e",
  strokeWidth: 1.5,
  d: "m53.17431,188.55474l-15.06253,15.06793l15.06393,15.06512l5.47909,-5.479l-9.5875,-9.58612l9.58551,-9.58614l-5.4785,-5.48179l0,0zm22.04519,0l-5.47513,5.48041l9.58554,9.58612l-9.58554,9.58495l5.47513,5.47897l15.06594,-15.0665l-15.06594,-15.06395z",
  id: "svg_174",
  stroke: "#d36200"
}), /*#__PURE__*/React.createElement("g", {
  id: "svg_3"
}, /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  fill: "#9db5b5",
  strokeWidth: 1.5,
  x: 457.42222,
  y: 461.18075,
  width: 142.99835,
  height: 138.76986,
  id: "svg_7"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  fill: "url(#svg_34)",
  strokeWidth: 1.5,
  strokeOpacity: "null",
  x: 430.12658,
  y: 460.8151,
  width: 31.70198,
  height: 139.94542,
  id: "svg_33"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  fill: "url(#svg_36)",
  strokeWidth: 1.5,
  strokeOpacity: "null",
  x: 461.30659,
  y: 431.18171,
  width: 139.27036,
  height: 30.43518,
  id: "svg_35"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "url(#svg_163)",
  strokeWidth: 1.5,
  x: 429.70945,
  y: 431.06112,
  width: 31.86972,
  height: 30.19364,
  id: "svg_37",
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#9db5b5",
  strokeWidth: 1.5,
  x: 513.90757,
  y: 454.26026,
  width: 31.70198,
  height: 17.27386,
  id: "svg_58",
  rx: 8,
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#e00000",
  strokeWidth: 0.5,
  x: 519.28822,
  y: 457.70857,
  width: 20.86029,
  height: 4.99472,
  id: "svg_130",
  rx: 100,
  stroke: "#333333"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#9db5b5",
  strokeWidth: 1.5,
  x: 456.26306,
  y: 528.16552,
  width: 10.30314,
  height: 30.43518,
  id: "svg_59",
  rx: 8,
  stroke: "null"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009e9e",
  strokeWidth: 1.5,
  d: "m516.71245,531.44211l-0.0193,41.40531l-12.22437,-13.62725l0.0193,-41.40531l37.14276,-0.0215l12.22437,13.62725l-37.14276,0.0215z",
  id: "svg_157",
  stroke: "#d36200"
}), /*#__PURE__*/React.createElement("rect", {
  transform: "rotate(90 461.7183532714843,543.7059326171876) ",
  fill: "#e00000",
  strokeWidth: 0.5,
  x: 451.28822,
  y: 541.20857,
  width: 20.86029,
  height: 4.99472,
  id: "svg_2",
  rx: 100,
  stroke: "#333333"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#009e9e",
  strokeWidth: 1.5,
  d: "m53.17431,52.55446l-15.06253,15.06793l15.06393,15.06512l5.47909,-5.479l-9.5875,-9.58612l9.58551,-9.58614l-5.4785,-5.48179l0,0zm22.04519,0l-5.47513,5.48041l9.58554,9.58612l-9.58554,9.58495l5.47513,5.47897l15.06594,-15.0665l-15.06594,-15.06395z",
  id: "svg_6",
  stroke: "#d36200"
}), /*#__PURE__*/React.createElement("g", {
  id: "svg_8"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#9db5b5",
  strokeWidth: 1.5,
  x: 116.14378,
  y: 281.7051,
  width: 40,
  height: 22.7025,
  id: "svg_119",
  rx: 8,
  transform: "rotate(-90 136.14378356933602,293.05627441406256) ",
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#e00000",
  strokeWidth: 0.5,
  x: 127.63359,
  y: 289.6641,
  width: 26.00732,
  height: 6.2271,
  id: "svg_120",
  rx: 100,
  transform: "rotate(-90 140.63725280761727,292.77758789062506) ",
  stroke: "#333333"
})), /*#__PURE__*/React.createElement("g", {
  id: "svg_13"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#9db5b5",
  strokeWidth: 1.5,
  x: 116.14378,
  y: 122.50477,
  width: 40,
  height: 22.7025,
  id: "svg_10",
  rx: 8,
  transform: "rotate(-90 136.14378356933597,133.85592651367188) ",
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#e00000",
  strokeWidth: 0.5,
  x: 127.63359,
  y: 130.46377,
  width: 26.00732,
  height: 6.2271,
  id: "svg_11",
  rx: 100,
  transform: "rotate(-90 140.63725280761722,133.57723999023438) ",
  stroke: "#333333"
})), /*#__PURE__*/React.createElement("g", {
  id: "svg_14"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#9db5b5",
  strokeWidth: 1.5,
  x: 116.14402,
  y: 448.72004,
  width: 40,
  height: 22.7025,
  id: "svg_122",
  rx: 8,
  transform: "rotate(-90 136.1440124511719,460.0711975097656) ",
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#e00000",
  strokeWidth: 0.5,
  x: 127.63383,
  y: 456.67904,
  width: 26.00732,
  height: 6.2271,
  id: "svg_123",
  rx: 100,
  transform: "rotate(-90 140.63748168945315,459.7925109863281) ",
  stroke: "#333333"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-90 516.7431640625001,85.50992584228511) ",
  id: "svg_25"
}, /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  fill: "#9db5b5",
  strokeWidth: 1.5,
  x: 459.02222,
  y: 30.77986,
  width: 142.99835,
  height: 138.76986,
  id: "svg_15"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  fill: "url(#svg_34)",
  strokeWidth: 1.5,
  strokeOpacity: "null",
  x: 431.72658,
  y: 30.41421,
  width: 31.70198,
  height: 139.94542,
  id: "svg_17"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  fill: "url(#svg_36)",
  strokeWidth: 1.5,
  strokeOpacity: "null",
  x: 462.9066,
  y: 0.78082,
  width: 139.27036,
  height: 30.43518,
  id: "svg_18"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "url(#svg_163)",
  strokeWidth: 1.5,
  x: 431.30945,
  y: 0.66023,
  width: 31.86972,
  height: 30.19364,
  id: "svg_19",
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#9db5b5",
  strokeWidth: 1.5,
  x: 515.50757,
  y: 23.85937,
  width: 31.70198,
  height: 17.27386,
  id: "svg_20",
  rx: 8,
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#e00000",
  strokeWidth: 0.5,
  x: 520.88822,
  y: 27.30768,
  width: 20.86029,
  height: 4.99472,
  id: "svg_21",
  rx: 100,
  stroke: "#333333"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#9db5b5",
  strokeWidth: 1.5,
  x: 457.86306,
  y: 97.76463,
  width: 10.30314,
  height: 30.43518,
  id: "svg_22",
  rx: 8,
  stroke: "null"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009e9e",
  strokeWidth: 1.5,
  d: "m518.31245,101.04122l-0.0193,41.40531l-12.22437,-13.62725l0.0193,-41.40531l37.14276,-0.0215l12.22437,13.62725l-37.14276,0.0215z",
  id: "svg_23",
  stroke: "#d36200"
}), /*#__PURE__*/React.createElement("rect", {
  transform: "rotate(90 463.3183288574219,113.30505371093754) ",
  fill: "#e00000",
  strokeWidth: 0.5,
  x: 452.88822,
  y: 110.80768,
  width: 20.86029,
  height: 4.99472,
  id: "svg_24",
  rx: 100,
  stroke: "#333333"
})));

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 600 600"
}, props), _ref, _ref2, _ref3);

export default __webpack_public_path__ + "static/media/ESW.e36c0558.svg";
export { SvgComponent as ReactComponent };